import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ButtonComponent } from "@components/button/button.component";
import { BlockComponent } from "@components/container-block/block.component";
import { DatepickerComponent } from "@components/datepicker/datepicker.component";
import { HeaderComponent } from "@components/header/header.component";
import { InputComponent } from "@components/input/input.component";
import { TextareaComponent } from "@components/textarea/textarea.component";
import moment from "moment";
import { ToastService } from "~app/common/components/toast/toast.service";
import { ApiClientService } from "~app/common/services/api-client.service";
import { migrateConfig } from "./migrate-config";

@Component({
    selector: "rask-sysadm-webinstallningar",
    templateUrl: "./sysadm-webinstallningar.component.html",
    styleUrls: ["./sysadm-webinstallningar.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        HeaderComponent,
        BlockComponent,
        InputComponent,
        FormsModule,
        TextareaComponent,
        DatepickerComponent,
        ButtonComponent
    ]
})
export class SysadmWebinstallningarComponent {
    configJson = JSON.stringify(migrateConfig);
    typAvMigrering = "MigrateSublayers";
    updatedBeforeDate = moment(new Date()).format("YYYY-MM-DD");

    private readonly apiClientService = inject(ApiClientService);
    private readonly toastService = inject(ToastService);

    protected sendConfig(): void {
        const body = {
            typAvMigrering: this.typAvMigrering,
            updatedBeforeDate: this.updatedBeforeDate,
            json: this.configJson
        };

        this.apiClientService.post<any, any>(`WebInstallning/migrate`, body, true).subscribe(
            {
                next: (_) => {
                    this.toastService.add(`Jobb för migrering av sublager lagt på kö!`);
                },
                error: (_) => {
                    this.toastService.add(`Något gick fel vid migreringsförsöket.`);
                }
            }
        );
    }
}
